import { render, staticRenderFns } from "./SmallCheckbox.vue?vue&type=template&id=4bede951&"
import script from "./SmallCheckbox.vue?vue&type=script&lang=js&"
export * from "./SmallCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports